export const widgetId = '#springbok_chatbot_widget'
export const widgetPluginsId = '#springbok_chatbot_widget_plugins'
export const messageType = { user: 0, bot: 1 }

export const testChatlineData = [
    { message: 'Hello', type: messageType.user },
    { message: 'Hello, how can I help? (link)[https://www.google.com/]', type: messageType.bot },
    { message: 'What can I talk to you about?', type: messageType.user },
    { message: `example...`, type: messageType.bot },
    { message: `Ok. Can we start?`, type: messageType.user },
    { message: '', video: 'https://www.youtube.com/embed/RW-jakmCcCc', type: messageType.bot},
    {
        message: `Sure, let's start by giving you some buttons to test.`,
        quicklink: {
            text: 'easyread',
            URL: 'https://google.com'
        },
        buttons: [
            {
                text: 'Hey',
                payload: '/greet',
            },
            {
                text: 'Hola',
                payload: '/greet',
            },
            {
                text: 'Good day',
                payload: '/greet',
            },
            {
                text: 'Hallo',
                payload: '/greet',
            },
        ],
        type: messageType.bot,
    }
]

function getCookie(name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}

export const apiCall = async (endpoint, jsonBodyData = { message: '', sender: '' }, successFn, failureFn = () => {}, debug = false) => {
    const controller = new AbortController()
    let fetchInit = {
        method: 'POST',
        signal: controller.signal,
        body: JSON.stringify(jsonBodyData),
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }

    // timeout for if server is unresponsive:
    const timeoutId = setTimeout(() => {
        let message = 'Request timed out'
        controller.abort()
        failureFn({ message })
        return false
    }, 8000)
    
    try {
        let response = await fetch(endpoint, fetchInit)
        clearTimeout(timeoutId)
        let responseOK = response?.ok ?? false
        let data = await response.json()
        if (debug) {
            console.log('Response from Rasa: ', data, '\nStatus: ', response.status)
        }
        if (responseOK) {
            successFn(data)
        } else {
            failureFn(data)
        }
        return responseOK
    } catch (e) {
        clearTimeout(timeoutId)
        failureFn(e)
        return false
    }
}

export const pingEndpoint = async (endpoint, successFn, failureFn = () => {}) => {
    const controller = new AbortController()
    let fetchInit = {
        method: 'GET',
        signal: controller.signal,
    }

    // timeout for if server is unresponsive:
    const timeoutId = setTimeout(() => {
        let message = 'Request timed out'
        controller.abort()
        failureFn({ message })
        return false
    }, 8000)
    
    try {
        let response = await fetch(endpoint, fetchInit)
        clearTimeout(timeoutId)
        let responseOK = response?.ok ?? false
        if (responseOK) {
            successFn()
        } else {
            failureFn()
        }
        return responseOK
    } catch (e) {
        clearTimeout(timeoutId)
        failureFn(e)
        return false
    }
}
